import Login from './views/Login.vue'
import Main from './views/Main.vue'
import Home from './views/Home.vue'
import NotFound from './views/404.vue'


import PortraitForUser from './views/PortraitForUser.vue'
import PortraitForEquipment from './views/PortraitForEquipment.vue'

import MessageCenter from './views/MessageCenter.vue'
import AccountManagement from './views/AccountManagement.vue'
import RoleManage from './views/RoleManage.vue'
import DealerManagement from './views/DealerManagement.vue'

import CustomerInformation from './views/CustomerInformation.vue'
import CustomerPopular from './views/CustomerPopular.vue'
import ActiveUser from './views/ActiveUser.vue'
import SeedCandidate from './views/SeedCandidate.vue'
import CustomerReservation from './views/CustomerReservation.vue'
import CustomerReservationed from './views/CustomerReservationed.vue'
import CustomerOpinion from './views/CustomerOpinion.vue'
import SmartCare from './views/SmartCare.vue'

import AfterSalesTracking from './views/AfterSalesTracking.vue'
import AfterSalesTrackingStand from './views/AfterSalesTrackingStand.vue'

import EquipmentInformation from './views/EquipmentInformation.vue'
import SportEquipment from './views/SportEquipment.vue'
import EquipmentMonitoring from './views/EquipmentMonitoring.vue'
import SportMonitoring from './views/SportMonitoring.vue'
import EquipmentMonitoringtest from './views/EquipmentMonitoringtest.vue'
import EquipmentCycleLog from './views/EquipmentCycleLog.vue'
import SportCycleLog from './views/SportCycleLog.vue'
import EquipmentFlash from './views/EquipmentFlash.vue'
import SportFlash from './views/SportFlash.vue'
import SportErr from './views/SportErr.vue'
import EquipmentBelow from './views/EquipmentBelow.vue'
import QRcodeDown from './views/QRcodeDown.vue'
import StorageEquipment from './views/StorageEquipment.vue'
import WarehousingEquipment from './views/WarehousingEquipment.vue'
import Log from './views/Log.vue'
import MobileAppUserManagement from "./views/MobileApp/MobileAppUserManagement";
import DeviceStatusManagement from "./views/DeviceStatusManagement";
import AnalyzeOverviewManagement from "./views/AnalyzeOverviewManagement";
import OverviewManagement from "./views/OverviewManagement";
import RemoteRehabitationServiceManagement from "./views/RemoteRehabitationServiceManagement";
import AnalyzeNewOnlineDeviceManagement from "./views/AnalyzeNewOnlineDeviceManagement";
import AnalyzeActiveDeviceManagement from "./views/AnalyzeActiveDeviceManagement";
import AnalyzeActivePeriodManagement from "./views/AnalyzeActivePeriodManagement";
import AnalyzeOnlineDurationManagement from "./views/AnalyzeOnlineDurationManagement";
import WheelDeviceStatusManagement from "./views/WheelDeviceStatusManagement";
import WheelChairMonitoring from "./views/WheelChairMonitoring";
import WheelChairCycleLog from "./views/WheelChairCycleLog"
import WheelChairFlash from "./views/WheelChairFlash";
import WheelChairErr from "./views/WheelChairErr";


const routes = [
  {
    path: '/login',
    component: Login,
    name: '',
    hidden: true
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
  },
  //{ path: '/main', component: Main },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/main', component: Main, name: ''}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/MessageCenter', component: MessageCenter, name: '消息中心'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/AccountManagement', component: AccountManagement, name: '后台账户管理'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/RoleManage', component: RoleManage, name: '角色管理'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/DealerManagement', component: DealerManagement, name: '经销商管理'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '用户及设备画像',
    iconCls: 'fa fa-address-card',
    children: [
      {path: '/PortraitForUser', component: PortraitForUser, name: '用户画像'},
      {path: '/PortraitForEquipment', component: PortraitForEquipment, name: '设备画像'},
    ]
  },
  {
    path: '/',
    component: Home,
    name: '客户管理',
    iconCls: 'fa fa-id-card-o',
    children: [
      {path: '/CustomerInformation', component: CustomerInformation, name: '客户信息管理'},
      {path: '/SmartCare', component: SmartCare, name: '智能看护'},
      {path: '/CustomerPopular', component: CustomerPopular, name: '客户推广管理'},
      {path: '/ActiveUser', component: ActiveUser, name: '北京福祉客户签到'},
      {path: '/SeedCandidate', component: SeedCandidate, name: '种子项目候选人'},
      {path: '/CustomerReservation', component: CustomerReservation, name: '未分配预约管理'},
      {path: '/CustomerReservationed', component: CustomerReservationed, name: '已分配预约管理'},
//          { path: '/CustomerOpinion', component: CustomerOpinion, name: '客户意见反馈' }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '售后管理',
    iconCls: 'fa fa-id-card-o',
    children: [
      {path: '/AfterSalesTracking', component: AfterSalesTracking, name: '产品信息跟踪[运动版]'},
      {path: '/AfterSalesTrackingStand', component: AfterSalesTrackingStand, name: '产品信息跟踪[标准版]'},

    ]
  },
  {
    path: '/',
    component: Home,
    name: '物联数据管理',
    iconCls: 'fa fa-id-card-o',
    children: [
      {path: '/EquipmentMonitoringtest', component: EquipmentMonitoringtest, name: '设备监控日志[测试]'},
      {path: '/EquipmentInformation', component: EquipmentInformation, name: '标准版设备'},
      {path: '/EquipmentMonitoring', component: EquipmentMonitoring, name: '设备监控日志[标准版]'},
      {path: '/EquipmentCycleLog', component: EquipmentCycleLog, name: '设备周期日志[标准版]'},
      {path: '/EquipmentFlash', component: EquipmentFlash, name: '设备Flash日志[标准版]'},
      {path: '/SportEquipment', component: SportEquipment, name: '运动版设备'},
      {path: '/SportMonitoring', component: SportMonitoring, name: '设备监控日志[运动版]'},
      {path: '/SportCycleLog', component: SportCycleLog, name: '设备周期日志[运动版]'},
      {path: '/SportFlash', component: SportFlash, name: '设备Flash日志[运动版]'},
      {path: '/SportErr', component: SportErr, name: '设备错误日志[运动版]'},
      {path: '/WheelChairMonitoring', component: WheelChairMonitoring, name: '设备监控日志[智能轮椅]'},
      {path: '/WheelChairCycleLog', component: WheelChairCycleLog, name: '设备周期日志[智能轮椅]'},
      {path: '/WheelChairFlash', component: WheelChairFlash, name: '设备Flash日志[智能轮椅]'},
      {path: '/WheelChairErr', component: WheelChairErr, name: '设备错误日志[智能轮椅]'},
    ]
  },
  {
    path: '/',
    component: Home,
    name: '生产流程管理',
    iconCls: 'fa fa-id-card-o',
    children: [
      {path: '/EquipmentBelow', component: EquipmentBelow, name: '设备下单管理'},
      {path: '/QRcodeDown', component: QRcodeDown, name: '二维码下载管理'},
      {path: '/StorageEquipment', component: StorageEquipment, name: '待入库设备管理'},
      {path: '/WarehousingEquipment', component: WarehousingEquipment, name: '已入库设备管理'},
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/Log', component: Log, name: '操作及安全日志'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/MobileAppUserManagement', component: MobileAppUserManagement, name: 'App用户管理'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    children: [
      {path: '/AnalyzeOverviewManagement', component: AnalyzeOverviewManagement, name: '概览'},
      {path: '/AnalyzeNewOnlineDeviceManagement', component: AnalyzeNewOnlineDeviceManagement, name: '新增上线'},
      {path: '/AnalyzeActiveDeviceManagement', component: AnalyzeActiveDeviceManagement, name: '活跃设备'},
      {path: '/AnalyzeActivePeriodManagement', component: AnalyzeActivePeriodManagement, name: '活跃周期'},
      {path: '/AnalyzeOnlineDurationManagement', component: AnalyzeOnlineDurationManagement, name: '连接时长'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/DeviceStatusManagement', component: DeviceStatusManagement, name: '设备状态'}
    ]
  },
  // {
  //   path: '/',
  //   component: Home,
  //   name: '',
  //   iconCls: 'fa fa-address-card',
  //   leaf: true,//只有一个节点
  //   children: [
  //     {path: '/WheelDeviceStatusManagement', component: WheelDeviceStatusManagement, name: '轮椅列表'}
  //   ]
  // },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {path: '/OverviewManagement', component: OverviewManagement, name: '概览1'}
    ]
  },
  {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'fa fa-address-card',
    leaf: true,//只有一个节点
    children: [
      {
        path: '/RemoteRehabitationServiceManagement',
        component: RemoteRehabitationServiceManagement,
        name: '远程康复服务'
      }
    ]
  },
//  {
//      path: '/',
//      component: Home,
//      name: '第一步',
//      iconCls: 'el-icon-message',//图标样式class
//      children: [
//          { path: '/main', component: Main, name: '主页', hidden: true },
//          { path: '/table', component: Table, name: 'Table' },
//          { path: '/form', component: Form, name: 'Form' },
//          { path: '/user', component: user, name: '列表' },
//      ]
//  },
//  {
//      path: '/',
//      component: Home,
//      name: '导航二',
//      iconCls: 'fa fa-id-card-o',
//      children: [
//          { path: '/table', component: Table, name: '页面4' },
//          { path: '/page5', component: Page5, name: '页面5' }
//      ]
//  },
//  {
//      path: '/',
//      component: Home,
//      name: '',
//      iconCls: 'fa fa-address-card',
//      leaf: true,//只有一个节点
//      children: [
//          { path: '/page6', component: Page6, name: '导航三' }
//      ]
//  },
//  {
//      path: '/',
//      component: Home,
//      name: 'Charts',
//      iconCls: 'fa fa-bar-chart',
//      children: [
//          { path: '/echarts', component: echarts, name: 'echarts' }
//      ]
//  },
//  {
//      path: '*',
//      hidden: true,
//      redirect: { path: '/404' }
//  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js